import { render } from "./PtOrdersExport.vue?vue&type=template&id=c84748c6&scoped=true"
import script from "./PtOrdersExport.vue?vue&type=script&lang=js"
export * from "./PtOrdersExport.vue?vue&type=script&lang=js"

import "./PtOrdersExport.vue?vue&type=style&index=0&id=c84748c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84748c6"]])

export default __exports__